/*jshint esversion: 6 */

/**
 * Mixin for opening a centered new window with custom proportions.
 *
 * @author Paul Marti - pablo@intermediatica.net
 * @mixin LocalStorageHandler
 * @constructor
 *
 * Ported as Vue Plugin by
 * Paul Marti <pablo@intermediatica.net>
 */

let VuePopupWindowPlugin = {};

VuePopupWindowPlugin.install = (Vue, options) => {

  Vue.mixin({
    methods: {
      popup(url, title) {
	
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
      
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
      
        var w = 630, h = 440, percent = 90; // default sizes
        
        if (window.screen) {
            w = window.screen.availWidth * percent / 100;
            h = window.screen.availHeight * percent / 100;        
        }
      
        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;
        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      
        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
        
      }
    }
  })
}

// Usage:
// $confirm.basic('Please confirm', result => console.log('confirmed'));

export default VuePopupWindowPlugin;